import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getRoles() {
    return this.http.get(
      `${this.baseUrl}/roles`
    );
  }

  getRoleById(id: number) {
    return this.http.get(
      `${this.baseUrl}/roles/${id}`
    );
  }

  createRole(payload: {
    name: string;
    description: string;
  }) {
    return this.http.post(
      `${this.baseUrl}/roles`,
      payload
    );
  }

  updateRole(
    id: number,
    payload: {
      id: number;
      name: string;
      description: string;
      permissions: {
        [key: string]: string[];
      };
    }
  ) {
    return this.http.put(
      `${this.baseUrl}/roles/${id}`,
      payload
    );
  }

  deleteRole(id: number) {
    return this.http.delete(
      `${this.baseUrl}/roles/${id}`
    );
  }
}